/**
 * @flow
 * @relayHash 9ffa253455ca6ca28b85414788ed2f14
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type getEventsV2QueryVariables = {|
  propertyId: string,
  startAt?: ?string,
  endAt?: ?string,
  type?: ?string,
|};
export type getEventsV2QueryResponse = {|
  +hyevents: {|
    +edges: $ReadOnlyArray<?{|
      +cursor: ?string,
      +node: ?{|
        +id: string,
        +title: string,
        +startAt: any,
      |},
    |}>
  |}
|};
export type getEventsV2Query = {|
  variables: getEventsV2QueryVariables,
  response: getEventsV2QueryResponse,
|};
*/


/*
query getEventsV2Query(
  $propertyId: ID!
  $startAt: String
  $endAt: String
  $type: String
) {
  hyevents(propertyId: $propertyId, startAt: $startAt, endAt: $endAt, type: $type) {
    edges {
      cursor
      node {
        id
        title
        startAt
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "propertyId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "startAt",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "endAt",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "type",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "hyevents",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "endAt",
        "variableName": "endAt"
      },
      {
        "kind": "Variable",
        "name": "propertyId",
        "variableName": "propertyId"
      },
      {
        "kind": "Variable",
        "name": "startAt",
        "variableName": "startAt"
      },
      {
        "kind": "Variable",
        "name": "type",
        "variableName": "type"
      }
    ],
    "concreteType": "Hyevents",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "EventNode",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "cursor",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Hyevent",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "title",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "startAt",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "getEventsV2Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "getEventsV2Query",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "getEventsV2Query",
    "id": null,
    "text": "query getEventsV2Query(\n  $propertyId: ID!\n  $startAt: String\n  $endAt: String\n  $type: String\n) {\n  hyevents(propertyId: $propertyId, startAt: $startAt, endAt: $endAt, type: $type) {\n    edges {\n      cursor\n      node {\n        id\n        title\n        startAt\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2291ed36959418cb0c7991fad6b99d72';
module.exports = node;
